var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import { ProgressStepper, Step, StepButton, StepLabel, } from '@one-thd/sui-atomic-components';
export var ChallengeStepper = function (_a) {
    var steps = _a.steps, inListDrawer = _a.inListDrawer, activeStep = _a.activeStep, url = _a.url;
    // --- Start of new logic ---
    var processedSteps = steps;
    var finalActiveStep = activeStep;
    if ((steps === null || steps === void 0 ? void 0 : steps.length) === 1) {
        var actualStep = steps[0];
        processedSteps = [
            {
                name: 'Challenge Opted In',
                completed: true,
                sequenceNumber: 1,
                url: null,
            },
            __assign(__assign({}, actualStep), { sequenceNumber: 2, completed: actualStep.completed }),
        ];
        finalActiveStep = 1;
    }
    var orientation = '';
    if (inListDrawer) {
        orientation = 'horizontal';
    }
    else {
        // Use the length of the processed steps to determine orientation
        orientation = (processedSteps === null || processedSteps === void 0 ? void 0 : processedSteps.length) < 3 ? 'horizontal' : 'vertical';
    }
    return (React.createElement("div", { className: "sui-w-full" },
        React.createElement(ProgressStepper, { orientation: orientation, activeStep: finalActiveStep - 1 }, processedSteps === null || processedSteps === void 0 ? void 0 : processedSteps.map(function (step) { return (React.createElement(Step, { key: "".concat(step === null || step === void 0 ? void 0 : step.name, " ").concat(step === null || step === void 0 ? void 0 : step.sequenceNumber), "aria-label": "".concat(step === null || step === void 0 ? void 0 : step.name, ". ").concat(step === null || step === void 0 ? void 0 : step.completed, "."), completed: step === null || step === void 0 ? void 0 : step.completed },
            React.createElement(StepButton, { text: "".concat(step === null || step === void 0 ? void 0 : step.sequenceNumber) }),
            !inListDrawer && (React.createElement(StepLabel, { title: React.createElement(React.Fragment, null, (step === null || step === void 0 ? void 0 : step.url) && finalActiveStep === step.sequenceNumber ? (React.createElement("a", { href: url, target: "_blank", className: "sui-text-base sui-font-regular sui-cursor-pointer sui-underline", rel: "noreferrer" }, step === null || step === void 0 ? void 0 : step.name)) : (React.createElement("span", { className: "sui-text-base sui-font-regular" }, step === null || step === void 0 ? void 0 : step.name))) })))); }))));
};
